<template>
  <ConfigErrorBoundary>
    <FileConverter
      :config="converterConfig"
      @batch-created="handleBatchCreated"
      @job-completed="handleJobCompleted"
      @batch-cleared="handleBatchCleared"
      @error="handleError"
      @credits-updated="handleCreditsUpdated"
    />
  </ConfigErrorBoundary>
</template>

<script setup lang="ts">
import FileConverter from './FileConverter.vue';
import ConfigErrorBoundary from './ConfigErrorBoundary.vue';
import { parseAndValidateConverterConfig } from '../utils/ConfigValidator';

const converterConfig = parseAndValidateConverterConfig('nef-to-webp-converter', 'Nikon NEF → WebP');

function handleBatchCreated(batchId: string) { console.log('[NEF to WebP] Batch created:', batchId); }
function handleJobCompleted(jobId: string) { console.log('[NEF to WebP] Job completed:', jobId); }
function handleBatchCleared() { console.log('[NEF to WebP] Batch cleared'); }
function handleError(error: Error) { console.error('[NEF to WebP] Error:', error); }
function handleCreditsUpdated(credits: number) { console.log('[NEF to WebP] Credits updated:', credits); }
</script>
